import React from 'react';
import styled from 'styled-components';

import { BG, FONT } from '../../styles/color';
import { Medium } from './Text';

const PostDetailContainer = styled.div`
	width: 100%;
	border-top: ${props => props.type === 'ANSWER' ? `3px solid ${BG.deep01}` : `3px solid ${FONT.mid}` };
	border-bottom: ${props => props.type === 'ANSWER' ? `3px solid ${BG.deep01}` : `3px solid ${FONT.mid}` };
	display: flex;
	flex-direction: column;
	gap: 0;
 	justify-content: flex-start;
	align-items: flex-start;
	background-color: ${props => props.type === 'ANSWER' ? BG.light02 : 'transparent' };
`;

const RowContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 15px 5px;
	box-sizing: border-box;
	border-bottom:  ${props => props.type === 'ANSWER' ? `1px solid ${BG.deep01}` : `1px solid ${FONT.mid}` };
`;

const MenuWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: flex-start;
	gap: 30px;
`;

const ContentWrapper = styled.div`
	width: 100%;
	padding: 30px 5px;
	box-sizing: border-box;
	min-height: 300px;
`;


export default function PostDetail(props) {
	if(props.type === 'ANSWER') {
		return (
			<PostDetailContainer type={ props.type }>
				<RowContainer type={ props.type }>
					<MenuWrapper>
						<div style={{ width: '80px'}}>
							<Medium size="18px" color={ BG.deep02 }>
								답변
							</Medium>
						</div>
					</MenuWrapper>
					<MenuWrapper>
						<div style={{ width: '80px'}}>
							<Medium size="18px" color={ BG.deep02 }>
								작성일자
							</Medium>
						</div>
						<div>
							<Medium size="18px" color={ FONT.default }>
								{ props.data.answerDate.split('T')[0] }
							</Medium>
						</div>
					</MenuWrapper>
				</RowContainer>
				<ContentWrapper>
					<Medium size="18px" color={ FONT.default }>
						{ props.data.content }
					</Medium>
				</ContentWrapper>
			</PostDetailContainer>
		)
	}

	return (
		<PostDetailContainer>
			<RowContainer>
				<MenuWrapper>
					<div style={{ width: '80px'}}>
						<Medium size="18px" color={ FONT.deep01 }>
							{ props.type === 'FAQ' ? '문의사항' : '주문제작' }
						</Medium>
					</div>
					<div>
						<Medium size="18px" color={ FONT.default }>
							{ props.data.title }
						</Medium>
					</div>
				</MenuWrapper>
			</RowContainer>
			<RowContainer>
				<MenuWrapper>
					<div style={{ width: '80px'}}>
						<Medium size="18px" color={ FONT.deep01 }>
							작성자
						</Medium>
					</div>
					<div>
						<Medium size="18px" color={ FONT.default }>
							{ props.data.author }
						</Medium>
					</div>
				</MenuWrapper>
				<MenuWrapper>
					<div style={{ width: '80px'}}>
						<Medium size="18px" color={ FONT.deep01 }>
							작성일자
						</Medium>
					</div>
					<div>
						<Medium size="18px" color={ FONT.default }>
							{ props.data.date }
						</Medium>
					</div>
				</MenuWrapper>
			</RowContainer>
			<ContentWrapper>
				<Medium size="18px" color={ FONT.default }>
					{ props.data.content }
				</Medium>
			</ContentWrapper>
		</PostDetailContainer>
	)
}
